module.exports = require("./fr-BI.d.ts");